import { ChangeEvent, useEffect, useState } from "react";
import LoadingApp from "../../../components/LoadingApp";
import './styles.css'
import { getGuiasParaRevalidacao } from "../../../services/MinhasGuiasService";
import { Pagination } from "@mui/material";
import { sxPagination } from "../../SaudeOnline/MeusAgendamentos/sxProps";
import { GuiaParaRevalidacao } from "../../../interfaces/entities/GuiaParaRevalidacao";
import RevalidationGuideCard from "./RevalidationGuideCard";
import RevalidationGuideModal from "./RevalidationGuideModal";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { sxPaginationContrast } from "../../../assets/styles/CommonSxProps";
import { scrollTo } from "../../../utils/ScrollUtil";
import PageTitle from "../../../components/Accessibility/PageTitle";

function RevalidacaoDeGuia() {
    const [myGuides, setMyGuides] = useState<GuiaParaRevalidacao[]>([]);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [idSolic, setIdSolic] = useState<string>('');
    const [open, setOpen] = useState<boolean>(false);
    const [reload, setReload] = useState<boolean>(false);

    const accessibility = useAccessibility();

    useEffect(() => {
        const getMyGuides = async () => {
            const resultProcs = await getGuiasParaRevalidacao();
            console.log(resultProcs)

            if (resultProcs !== null) {
                setMyGuides(resultProcs)
                setShowLoading(false);
            }
        }

        setShowLoading(true);
        getMyGuides();
    }, [reload]);

    const paginatedDoctors = myGuides.slice(
        (page - 1) * 5,
        page * 5
    );

    const handlePageChange = (event: ChangeEvent<unknown>, newPage: number) => {
        setPage(newPage);
        scrollTo('scroll-ref');

    };

    const handleGuideRevalidation = (value: string) => {
        setIdSolic(value)
        setOpen(true);
    }

    const handleClose = (value: boolean) => {
        setIdSolic('')
        setOpen(false);
        if (value) {
            setReload(!reload)
        }
    }

    const handleLoading = (value: boolean) => {
        setShowLoading(value)
    }

    return (
        <div className="my-guides-content">
            <LoadingApp showLoading={showLoading} />
            <div id='scroll-ref' />
            <PageTitle text="Revalidação de guias" />
            <p className='my-guides-instructions' style={accessibility.textStyleAccessibility}>
                Esta funcionalidade permite a revalidação de guias vencidas conforme alguns critérios:
            </p>
            <div className="revalidation-instructions" style={{ ...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
                <ul>
                    <li style={accessibility.textStyleAccessibility}>É permitida a revalidação de guias dentro da validade, mas que necessitam de um prazo maior para realização.</li>
                    <li style={accessibility.textStyleAccessibility}>Guias vencidas, mas com emissão há menos de 180 dias, também podem ser revalidadas.</li>
                    <li style={accessibility.textStyleAccessibility}>Não será permitido revalidar mais de duas vezes a mesma guia.</li>
                </ul>
            </div>
            <h1 className="guide-activation-subtitle-re" style={accessibility.textStyleAccessibility}>Guias para revalidação</h1>
            {myGuides.length === 0 &&
                <h1 className='empty-notifications' style={accessibility.textStyleAccessibility}>Você não possui guia disponível para revalidação.</h1>
            }
            {myGuides.length > 0 &&
                <div className="doctors-cards-list">
                    {paginatedDoctors.map((guide, index) => (
                        <RevalidationGuideCard guide={guide} key={`${guide.idSolic}-${index}`} handleGuideRevalidation={handleGuideRevalidation} handleLoading={handleLoading} />
                    ))}
                </div>
            }
            {myGuides.length > 5 &&
                <div className='pagination-holder'>
                    <Pagination
                        count={Math.ceil(myGuides.length / 5)}
                        sx={accessibility.contrastMode ? sxPaginationContrast : sxPagination} hideNextButton hidePrevButton
                        color='primary'
                        page={page}
                        onChange={handlePageChange}
                    />
                </div>
            }
            <RevalidationGuideModal open={open} idSolic={idSolic} handleClose={handleClose} />
        </div>
    )
}

export default RevalidacaoDeGuia;